<form class="-devsite-search-form" [class.expanded]="expanded" (ngSubmit)="$event.preventDefault()">
  <span class="search-input-container">
    <span class="search-icon">
       <div class="search-icon-bg"></div>
    </span>
    <input
      id="-search-input"
      type="text"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      (click)="onFocus()"
      (blur)="onInputBlur($event)"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off" />
  </span>

  <div *ngIf="expanded && enableBackdrop" class="search-backdrop"></div>
  <div *ngIf="expanded && enableBackdrop" class="results-popup" tabindex="-1">
    <ng-container *ngIf="searchResults$ | async as results">
      <div *ngIf="suggestedWord || localSearchProduct || initialFacetResults" class="action-card">
        <div class="action-row">
          <ng-container *ngIf="suggestedWord && results.ResultItems?.length === 0">
            <div class="correction-container">
              <span class="correction-link">
                Did you mean&nbsp;
                <b (click)="applyCorrection(suggestedWord)">{{ suggestedWord }}</b>?
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="localSearchProduct && !suggestedWord">
            <app-local-search
              [toggleActive]="localSearchToggleActive"
              (toggleActiveChange)="onLocalSearchToggleChange($event)"
              [localSearchProduct]="localSearchProduct"
              (localSearchProductEmitter)="localSearchProductHandler($event)">
            </app-local-search>
          </ng-container>
          <app-filter
            *ngIf="(!suggestedWord && (results.ResultItems?.length !== 0)) || initialFacetResults"
            [filterValues]="filterList"
            [facetResponse]="initialFacetResults"
            [selectedValues]="selectedFilterValues"
            (selectionChange)="onSelectionChange($event)">
          </app-filter>
        </div>
      </div>
      <div *ngIf="results.ResultItems?.length === 0 || noResultMode" class="no-results-container">
        <div class="no-results-text">No results</div>
        <div class="no-results-text">
          Try using other terms, use our
          <app-link [to]="solutionFinderResponse.path" class="no-results-link">Solution Finder, </app-link>
          or
          <app-link [to]="solutionFinderResponse.contactSupport" class="no-results-link">Contact Support</app-link>
        </div>
      </div>
      <div class="result-container" *ngIf="results.ResultItems?.length > 0 && !noResultMode">
        <div class="result-item" *ngFor="let searchResult of results.ResultItems | slice : 0 : resultSliceCount">
          <app-search-card (clearSearchInput)="clearSearchInput()"
            [searchCardResponse]="searchResult"
            [isLoading]="isLoading"
            [showSkeleton]="isLoading"
          ></app-search-card>
        </div>
      </div>
      <a href="/results" *ngIf="showAllResults && !noResultMode && !isLoading" (click)="onShowAll($event)" class="show-all-results-link">
        Show all results
      </a>
    </ng-container>
    <solution-finder-card
      class="solutionfinder-card"
      [solutionFinderResponse]="solutionFinderResponse">
    </solution-finder-card>
  </div>
</form>